import React, {PureComponent} from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { includes } from 'lodash';
import { Cookies } from 'react-cookie';
import PropTypes from 'prop-types';
import messages from '../../utils/translationMessages';
import { PortalConfigContext } from '../../config/portal';
import { getAssetUrl } from '../../utils/commonHelper';
import { APP_BANNER_COOKIE } from '../../constants/cookies';
import { registerDownloadApp } from '../../store/actions/dataLayer';
import { getPageParams } from '../../utils/dataLayerHelper';
import classnames from 'classnames';
import './styles.css';
import { getPortalName } from '../../utils/language';

class AppBanner extends PureComponent {
  bannerRef = React.createRef();

  state = {
    isVisible: false,
    appStoreLink: '',
    bannerHeight: 0
  }


  handleCloseButton = () => {
    const { cookies, getAppBannerHeight } = this.props;
    const inOneDay = new Date();
    inOneDay.setDate( inOneDay.getDate() + 1 );
    const data = {
      value: 1,
      expires: inOneDay,
      path: '/'
    };
    cookies.set(APP_BANNER_COOKIE, 1, data);
    this.setState({
      isVisible: false,
      bannerHeight: 0
    }, () => getAppBannerHeight(this.state.bannerHeight));
  }

  handleDownloadButton = () => {
    const { pageType } = this.props;
    const portal = getPortalName(this.context);
    const params = getPageParams(pageType);
    const detailedPageName = params.detailedPageName;
    this.props.registerDownloadApp(detailedPageName, portal);

    setTimeout(() => {
      window.location.href = this.state.appStoreLink;
    }, 400);
  }

  componentDidMount() {
    const { pageType } = this.props;
    const pagesAllowedToShowBanner = ['Home', 'SearchResults', 'BoatDetails'];
    const isPageAllowedToShowBanner = includes(pagesAllowedToShowBanner, pageType);

    if (isPageAllowedToShowBanner) {
      const bannerContext = this.context.banner;
      const { cookies = {}, getAppBannerHeight } = this.props;
      if (bannerContext && cookies.cookies && !cookies.cookies[APP_BANNER_COOKIE]) {
        const iphone = window.navigator.userAgent.match(/iPhone/g);
        const android = window.navigator.userAgent.match(/Android/g);
        if (iphone || android) {
          this.setState({
            isVisible: true,
            appStoreLink: iphone ? bannerContext.appStoreLink.iphone : bannerContext.appStoreLink.android,
          }, () => {
            getAppBannerHeight(this.state.bannerHeight);
          });
        }
      }
    }

  }

  componentDidUpdate(prevProps, prevState) {
    const { getAppBannerHeight } = this.props;
    if (prevState.isVisible !== this.state.isVisible) {
      this.setState({
        bannerHeight: this.state.isVisible ? this.bannerRef.current.clientHeight || 52 : 0
      }, () => {
        getAppBannerHeight(this.state.bannerHeight);
      });
    }
  }

  render(){
    const { banner: bannerContext } = this.context;
    const portal = getPortalName(this.context);

    if (!bannerContext) {
      return (null);
    }

    const { intl: { formatMessage: t } } = this.props;
    const bannerLayout = bannerContext.layout;
    return (
      <div ref={this.bannerRef} className={classnames(`app-banner-${bannerLayout}`, 'js-app-banner', { 'is-visible': this.state.isVisible })}>
        { bannerLayout === 'top' && <div onClick={this.handleCloseButton} className="app-banner__close js-app-banner-close">✕</div> }
        <img className={`app-banner__logo-${bannerLayout}`} alt={t(messages.banner.download.title, { portal })}
          src={getAssetUrl(bannerContext.logo)}/>
        <div className={`app-banner__text-${bannerLayout}`}>
          <span className="app-banner__title">{t(messages.banner.download.title, { portal })}</span>
          <span className={`app-banner__sub-title-${bannerLayout}`}>{t(messages.banner.download.description)}</span>
        </div>
        <span className={classnames(`app-banner__button-${bannerLayout}`, 'js-app-download-button')} onClick={this.handleDownloadButton}>{t(messages.banner.download.open)}</span>
        { bannerLayout === 'overlay' && <span className="app-banner__close js-app-banner-close" onClick={this.handleCloseButton}>{t(messages.banner.download.close)}</span> }
      </div>
    );
  }
}

AppBanner.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  cookies: PropTypes.instanceOf(Cookies),
  pageType: PropTypes.string,
  registerDownloadApp: PropTypes.func,
  getAppBannerHeight: PropTypes.func
};

AppBanner.contextType = PortalConfigContext;

export default connect(
  null,
  (dispatch) => bindActionCreators({
    registerDownloadApp
  }, dispatch)
)(injectIntl(AppBanner));
